import { axiosInstance } from '@configs/axios/axiosInstance';

import type { GetInvoiceFileRequest } from './getInvoiceFile.types';

export async function getInvoiceFile({
  id,
  organizationId,
}: GetInvoiceFileRequest): Promise<Blob> {
  const response = await axiosInstance.get<Blob>(`/invoices/${id}/download`, {
    headers: {
      'X-Organization-Id': organizationId,
    },
    responseType: 'blob',
  });
  return response.data;
}
